import { useStopWatchBasic } from "global-components-library";

import { useEffect } from "react";

const StopWatch = ({ onChange, running }) => {
  let { start, stop, fullFormat, seconds } = useStopWatchBasic();

  useEffect(() => {
    if (running) {
      start();
    } else {
      stop();
    }
    return () => {
      stop();
    }
  }, [running]);

  useEffect(() => {
    onChange(fullFormat());
  }, [seconds]);

  return "";
};

export default StopWatch;



// WEBPACK FOOTER //
// ./src/components/workSpace/CallComponents/StopWatch/StopWatch.jsx